import { callEdge } from "@/lib/edgeClient"

export interface DebugVideo {
  id: string
  mux_asset_id: string | null
  mux_playback_id: string | null
  status: string
  created_at: string
  user_id: string
  [key: string]: any
}

export interface DebugVideosResponse {
  videos: DebugVideo[]
  count: number
}

export interface DebugTelemetryResponse {
  run: any
  has_telemetry_ai: boolean
  has_ai_meta: boolean
  has_ai_mediapipe_v1: boolean
}

export interface DebugAnalysisRun {
  id: string
  video_asset_id: string
  user_id: string
  status: string
  created_at: string
  telemetry_ai?: any
  ai_meta?: any
  ai_mediapipe_v1?: any
  [key: string]: any
}

export interface DebugAnalysisResponse {
  runs: DebugAnalysisRun[]
  count: number
}

export interface DebugRepairResponse {
  success: boolean
  repaired: number
  failed: number
  results: Array<{
    video_id: string
    asset_id?: string
    status: string
    reason?: string
  }>
  message: string
}

export async function searchVideos(videoId?: string, assetId?: string, playbackId?: string): Promise<DebugVideosResponse> {
  try {
    const params = videoId 
      ? `video_id=${videoId}` 
      : assetId 
      ? `asset_id=${assetId}` 
      : `playback_id=${playbackId}`
    const data = await callEdge(`admin-debug-videos?${params}`, {
      method: 'GET',
      authRequired: true,
    })
    return data as DebugVideosResponse
  } catch (error) {
    console.error('[searchVideos] Error:', error)
    throw error
  }
}

export async function getTelemetry(runId: string): Promise<DebugTelemetryResponse> {
  try {
    const data = await callEdge(`admin-debug-telemetry?run_id=${runId}`, {
      method: 'GET',
      authRequired: true,
    })
    return data as DebugTelemetryResponse
  } catch (error) {
    console.error('[getTelemetry] Error:', error)
    throw error
  }
}

export async function getAnalysisRuns(videoAssetId: string): Promise<DebugAnalysisResponse> {
  try {
    const data = await callEdge(`admin-debug-analysis?video_asset_id=${videoAssetId}`, {
      method: 'GET',
      authRequired: true,
    })
    return data as DebugAnalysisResponse
  } catch (error) {
    console.error('[getAnalysisRuns] Error:', error)
    throw error
  }
}

export async function rerunAnalysis(runId: string): Promise<{ success: boolean; run: DebugAnalysisRun; message: string }> {
  try {
    const data = await callEdge('admin-debug-analysis', {
      method: 'POST',
      body: { action: 'rerun', run_id: runId },
      authRequired: true,
    })
    return data as { success: boolean; run: DebugAnalysisRun; message: string }
  } catch (error) {
    console.error('[rerunAnalysis] Error:', error)
    throw error
  }
}

export async function cancelAnalysis(runId: string): Promise<{ success: boolean; message: string }> {
  try {
    const data = await callEdge('admin-debug-analysis', {
      method: 'POST',
      body: { action: 'cancel', run_id: runId },
      authRequired: true,
    })
    return data as { success: boolean; message: string }
  } catch (error) {
    console.error('[cancelAnalysis] Error:', error)
    throw error
  }
}

export async function repairVideos(action: 'fix_playback_id' | 'sync_mux', videoId?: string): Promise<DebugRepairResponse> {
  try {
    const data = await callEdge('admin-debug-videos-repair', {
      method: 'POST',
      body: { action, video_id: videoId },
      authRequired: true,
    })
    return data as DebugRepairResponse
  } catch (error) {
    console.error('[repairVideos] Error:', error)
    throw error
  }
}





